import { INTERNATIONALIZATION_UNITS, INTERNATIONALIZATION_DATE, INTERNATIONALIZATION_DATE_MASK } from '../../../../../constants/constants';
import i18n from '@/i18n';

export default {
    name: 'UserDialogInternationalizationTabComponent',
    components: {
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,            required: true
        },
        validationRules:{
            type: Object,
            required: true
        },
        validForm:{
            type: Boolean,
            required: true
        },
        resetFormValidation:{
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,       
        units: INTERNATIONALIZATION_UNITS,
        dates:INTERNATIONALIZATION_DATE,
        dateMasks: INTERNATIONALIZATION_DATE_MASK,    
        table:[
            {
              unit: i18n.t('internationalization.units.names.mass'),
              simela:i18n.t('internationalization.units.kilogram'),
              imperial:i18n.t('internationalization.units.pound'),
              latin: i18n.t('internationalization.units.kilogram')
            },
            {
              unit: i18n.t('internationalization.units.names.volume'),
              simela:i18n.t('internationalization.units.liter'),
              imperial:i18n.t('internationalization.units.gallon'),
              latin:i18n.t('internationalization.units.liter')
            },
            {
              unit: i18n.t('internationalization.units.names.temperature'),
              simela:i18n.t('internationalization.units.celsius') ,
              imperial:i18n.t('internationalization.units.fahrenheit'),
              latin:i18n.t('internationalization.units.celsius')
            },
            {
              unit: i18n.t('internationalization.units.names.time'),
              simela:i18n.t('internationalization.units.second'),
              imperial:i18n.t('internationalization.units.second'),
              latin:i18n.t('internationalization.units.second')
            },
            {
              unit: i18n.t('internationalization.units.names.pressure'),
              simela:i18n.t('internationalization.units.bar'),
              imperial:i18n.t('internationalization.units.psi'),
              latin:i18n.t('internationalization.units.psi')
          
            },  
            {
              unit: i18n.t('internationalization.units.names.speed'),
              simela:i18n.t('internationalization.units.kmPerHour'),
              imperial:i18n.t('internationalization.units.milePerHour'),
              latin:i18n.t('internationalization.units.kmPerHour')
          
            },
            {
              unit: i18n.t('internationalization.units.names.area'),
              simela:i18n.t('internationalization.units.hectare'),
              imperial:i18n.t('internationalization.units.acre'),
              latin:i18n.t('internationalization.units.hectare')
          
            },
            {
              unit: i18n.t('internationalization.units.names.speedByRevolution'),
              simela:i18n.t('internationalization.units.rpm'),
              imperial:i18n.t('internationalization.units.rpm'),
              latin:i18n.t('internationalization.units.rpm')
          
            },
            {
              unit: i18n.t('internationalization.units.names.distance'),
              simela:i18n.t('internationalization.units.kilometers'),
              imperial:i18n.t('internationalization.units.miles'),
              latin:i18n.t('internationalization.units.kilometers')
          
            },
            {
              unit: i18n.t('internationalization.units.names.navigationLength'),
              simela:i18n.t('internationalization.units.miles'),
              imperial:i18n.t('internationalization.units.miles'),
              latin:i18n.t('internationalization.units.miles')
          
            }],
        headers: [
            {
              text: i18n.t('internationalization.unit'),
              value: 'unit'
            }
          ],
    }),
    computed: {
       
    },
    created () {
        
    },
    mounted () {
        if (this.model.internationalization.unit === null)
            this.model.internationalization.unit = this.units[0].name;
        if (this.model.internationalization.date === null) 
            this.model.internationalization.date = this.dates[0];
        if (this.model.internationalization.dateMask === null) 
            this.model.internationalization.dateMask = this.dateMasks[0];
        INTERNATIONALIZATION_UNITS.forEach(element => {
                this.headers.push({
                    text: i18n.t(element.translate),
                    value: element.name
                  })      
                
            });


    },
    methods: {
       
    },
    watch: {
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm (newVal, oldVal) {
            if (newVal!==oldVal) {
                this.$emit('update:validForm', newVal)
            }
        }      
    }
}
